module.exports = __webpack_public_path__ + "img/huoqing.7b31f676.svg";